// extracted by mini-css-extract-plugin
var _1 = "CreatePasswordFormRequirements-moduleCreatePasswordFormRequirements__ZyjMq";
var _2 = "CreatePasswordFormRequirements-modulelist__bfYQ2";
export { _1 as "CreatePasswordFormRequirements", _2 as "list" }
